// extracted by mini-css-extract-plugin
export var button = "styles-module--button--ee01e";
export var container = "styles-module--container--70698";
export var desktop = "1340px";
export var giant = "2200px";
export var heading = "styles-module--heading--b0b14";
export var icon = "styles-module--icon--8e2eb";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var socialLinks = "styles-module--socialLinks--918cd";
export var tablet = "768px";